var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Columns, InputText, SelectionList, } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useLanguageSelectionList, } from 'utils/useLanguageSelectionList';
import { useLanguageSelectionListItems } from 'utils/useLanguageSelectionListItems';
/**
 * Represents a selection list of languages for translating text to a selected
 * language.
 */
export const TranslateTextLanguageSelectionList = (props) => {
    const { autoFocusSearch, revertLabel = 'Show original message', selectedLanguageCode, onLanguageChange, onRevert, sortFn = (a, b) => a.name.localeCompare(b.name), } = props;
    const [searchTerm, setSearchTerm] = useState('');
    const [isActive, setIsActive] = useState(false);
    const inputRef = useRef(null);
    const languageSelectionListOptions = useMemo(() => ({
        selectedLanguageCodes: selectedLanguageCode
            ? [selectedLanguageCode]
            : undefined,
    }), [selectedLanguageCode]);
    const { languages, selectedLanguages, clearSelection, onChange, recentlyUsedLanguagesCodes, } = useLanguageSelectionList(languageSelectionListOptions);
    const showRevert = !!(onRevert && selectedLanguages.length);
    const languageSelectionListItems = useLanguageSelectionListItems({
        languages,
        searchTerm,
        recentlyUsedLanguagesCodes,
        revertLabel,
        showRevert,
        sortFn,
    });
    const handleOnChange = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        const { selectedItem } = event;
        const { value } = selectedItem;
        if (onRevert && typeof value === 'string' && value === 'revert') {
            onLanguageChange === null || onLanguageChange === void 0 ? void 0 : onLanguageChange({});
            onRevert();
            clearSelection();
            return;
        }
        const selectedLanguage = value;
        if (selectedLanguages.some(({ code }) => selectedLanguage.code === code)) {
            return;
        }
        onLanguageChange === null || onLanguageChange === void 0 ? void 0 : onLanguageChange({ selectedLanguage });
        onChange(event);
    }), [clearSelection, onChange, onLanguageChange, onRevert, selectedLanguages]);
    useEffect(() => {
        if (autoFocusSearch && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocusSearch]);
    return (_jsx(Columns, Object.assign({ style: { height: 260, width: 320 } }, { children: _jsxs(Column, { children: [_jsx(Column.Row, Object.assign({ noHorizontalPadding: true, noVerticalPadding: true, noMinHeight: true, style: {
                        padding: sizes.spacer[200],
                    } }, { children: _jsx(InputText, { ref: inputRef, value: searchTerm, onChange: (event) => setSearchTerm(event.target.value), onFocus: () => setIsActive(true), onBlur: () => setIsActive(false) }) })), _jsx(Column.Row, Object.assign({ noHorizontalPadding: true, noVerticalPadding: true, noMinHeight: true, scrollable: true }, { children: _jsx(SelectionList, Object.assign({ isActive: isActive, style: {
                            padding: sizes.spacer[200],
                        }, selectedValues: selectedLanguages, onChange: handleOnChange }, { children: languageSelectionListItems })) }))] }) })));
};
